/*
 * @Author: edvardchen
 * @Date: 2017-12-27 17:42:34
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:39:35
 */

// @flow
import React from 'react';
import sanitizeComment from '../../../utility/sanitizeComment';

import styles from './index.scss';

export default function renderCommentContent(content: string, context: Object) {
  const { onTalkClick } = context;
  /* eslint-disable no-param-reassign */
  context.startKey = context.startKey || 0;
  return sanitizeComment(content)
    .map((item, index) => {
      context.startKey += 1;
      const key = `${context.startKey}_${index}`;
      if (typeof item === 'string') {
        if (!item.length) {
          return null;
        }
        return <span key={key}>{item}</span>;
      }
      switch (item.type) {
        case 'emotion':
          return <img key={key} src={item.src} alt="" className={styles.emotion} />;
        case 'talk':
          return (
            <a
              href={`https://quan.qq.com/talk/${item.id}`}
              style={{ color: '#4f7cb8' }}
              key={key}
              onClick={(event) => onTalkClick && onTalkClick(event, item)}
            >
              {' '}
              {`#${item.title}#`}{' '}
            </a>
          );
        default:
          return null;
      }
    })
    .filter(Boolean);
}
